import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { AlertLabs, units } from '@hbf/dsl';
import { StudentResidenceLargeBold } from '@ha/icons';
import { useIntl } from 'ha/i18n';
import { useCookie } from 'ha/pages/Search/hooks/useCookie';
import { makeStyles } from 'tss-react/mui';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { Cookies as CookiesConstants } from 'ha/constants/Cookies';
import { getTypeFilterValue } from 'ha/pages/Search/selectors/filterSelectors';
import { useSelector } from 'react-redux';
import { TypeValue } from 'ha/types/SearchFilters';

const useStyles = makeStyles()(theme => ({
  icon: {
    color: theme.palette.primary.dark,
  },
  buttonLink: {
    textTransform: 'capitalize',
    color: theme.palette.primary.dark,
    cursor: 'pointer',
  },
  container: {
    marginBottom: units.rem(1),
  },
}));

export const StudentResidenceNoticeBannerWithActions = React.memo(() => {
  const { T } = useIntl();
  const { md } = useMediaQuery();
  const { classes } = useStyles();
  const [cookie, updateCookie] = useCookie(
    CookiesConstants.STUDENT_RESIDENCE_NOTICE_BANNER_SHOWN,
  );
  const searchParamsCategories = useSelector(getTypeFilterValue);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const hasStudentHousingCategory = React.useMemo(
    () => searchParamsCategories.includes(TypeValue.STUDENT_HOUSING),
    [searchParamsCategories],
  );

  useEffect(() => {
    if (cookie) {
      setIsOpen(false);
      return;
    }
    setIsOpen(true);
  }, [cookie]);

  const handleClose = React.useCallback(() => {
    updateCookie('accepted', {
      expires: dayjs().add(1, 'week').toDate(),
    });
    setIsOpen(false);
  }, [updateCookie]);

  if (isOpen && hasStudentHousingCategory) {
    return (
      <AlertLabs
        icon={
          md ? <StudentResidenceLargeBold className={classes.icon} /> : false
        }
        severity="info"
        onClose={handleClose}
        className={classes.container}
      >
        {T('student_accommodation.search_page.banner_text')}
      </AlertLabs>
    );
  }
  return null;
});
